<loren-page-content>
    <mat-card-title class="loren-automation-plan-define-title">
    {{
      (rule
        ? "automation_plans_form.edit_rule"
        : "automation_plans_form.create_rule"
      ) | transloco
    }}
  </mat-card-title>
  <loren-automation-plan-section [number]="1">
    <form class="loren-automation-plan-grid-form" [formGroup]="baseForm">
      @if(canSelectRuleScope) {
      <div class="loren-automation-plan-grid-full-width" style="margin-bottom: 16px">
        <div>{{ "automation_plans_form.rule_scope" | transloco }}</div>
        <mat-radio-group
          style="display: flex; gap: 16px"
          formControlName="isCompanyLevel">
          <mat-radio-button [value]="false">{{
            "automation_plans_form.personal_rule" | transloco
          }}</mat-radio-button>
          <mat-radio-button [value]="true">{{
            "automation_plans_form.company_rule" | transloco
          }}</mat-radio-button>
        </mat-radio-group>
      </div>
      }
      <mat-form-field
        required
        class="loren-form-field loren-form-field-automation-plan loren-automation-plan-grid-full-width"
        [tourAnchor]="nameAnchorId"
        [ngClass]="{
          'loren-form-field-automation-plan--with-value': ruleNameField.value,
          'hide-hint-unless-focused': ruleNameField.value
        }"
        [hideRequiredMarker]="false">
        <mat-label for="ruleName">{{
          "automation_plans_form.rule_title" | transloco
        }}</mat-label>
        <input
          lorenAutofocus
          matInput
          #ruleNameInput
          id="ruleName"
          formControlName="ruleName"
          [style.width]="'100%'" />
        @if(ruleNameField.value) {
        <mat-icon matSuffix class="loren-automation-plan-edit"> edit </mat-icon>
        }
        <mat-hint
          >{{ "automation_plans_form.rule_hint" | transloco }} ({{
            baseForm.controls.ruleName?.value?.length
          }}
          / 100)</mat-hint
        >
        <mat-error>
          @if (baseForm.controls.ruleName.hasError('required')) {
          <span>{{ "automation_plans_form.required" | transloco }}</span>
          } @else {
          <span>{{ "automation_plans_form.rule_too_long" | transloco }}</span>
          }
        </mat-error>
      </mat-form-field>

      <div class="loren-automation-plan-define-base-days">
        <mat-form-field
          required
          appearance="outline"
          class="loren-form-field loren-form-field-automation-plan"
          [hideRequiredMarker]="false"
          [ngClass]="{
            'loren-form-field-automation-plan--with-value': daysField.value
          }">
          <mat-label>{{
            "automation_plans_form.period" | transloco
          }}</mat-label>
          <mat-select [multiple]="true" formControlName="days">
              <mat-option select-all value="all">{{ "days_of_week.everyday" | transloco }}</mat-option>

            @for ( day of allDays; track day) {
            <mat-option [value]="day">{{
              "days_of_week." + day | transloco
            }}</mat-option>
            }
          </mat-select>
          @if(daysField.value) {
          <mat-icon matSuffix class="loren-automation-plan-edit">
            edit
          </mat-icon>
          }
        </mat-form-field>
      </div>
      <div class="loren-automation-plan-define-base-hours">
        <p>{{ "automation_plans_form.hours" | transloco }}</p>
        <div>
          <mat-form-field
            appearance="outline"
            class="loren-form-field loren-form-field-automation-plan loren-automation-plan-define-time-field"
            [tourAnchor]="periodAnchorId">
            <mat-label>{{ "automation_plans_form.start" | transloco }}</mat-label>
            <input matInput type="time" formControlName="startingTime" />
          </mat-form-field>
          –
          <mat-form-field
            appearance="outline"
            class="loren-form-field loren-form-field-automation-plan loren-automation-plan-define-time-field">
            <mat-label>{{ "automation_plans_form.end" | transloco }}</mat-label>
            <input matInput type="time" formControlName="endingTime" />
          </mat-form-field>
          @if(isHandset) {
          <br />
          }
          {{ "automation_plans.or" | transloco }}
          <mat-checkbox formControlName="wholeDay">
            {{ "automation_plans_form.whole_day" | transloco }}
          </mat-checkbox>
        </div>
      </div>
      <div
        style="display: flex; flex-direction: column; height: 120px"
        [tourAnchor]="delayAnchorId">
        <mat-form-field
          required
          appearance="outline"
          class="loren-form-field loren-form-field-automation-plan"
          [ngClass]="{
            'loren-form-field-automation-plan--with-value': delayField.value
          }">
          <mat-label>{{ "automation_plans_form.delay" | transloco }}</mat-label>
          <mat-select formControlName="delay">
            @for (option of timeConditionOptions; track option; let idx =
            $index) {
            <mat-option [value]="option.value.toString()">
              {{
                option.value
                  ? (option.key
                    | transloco
                      : {
                          value:
                            idx <= 12 ? option.value / 60 : option.value / 3600
                        })
                  : (option.key | transloco)
              }}
            </mat-option>
            }
          </mat-select>
          @if(!confirmDeleteDelay()) {
          <mat-hint>{{
            "automation_plans_form.delay_hint" | transloco
          }}</mat-hint>
          } @if(delayField.value) {
          <div matSuffix style="display: flex; gap: 4px; margin: 0 4px">
            <mat-icon class="loren-automation-plan-edit"> edit </mat-icon>
            <mat-icon
              class="loren-automation-plan-edit"
              style="z-index: 2"
              (click)="$event.stopPropagation(); confirmDeleteDelay.set(true)">
              close
            </mat-icon>
          </div>

          }
        </mat-form-field>
        @if(confirmDeleteDelay()) {
            <div class="loren-automation-plan-confirm-delete">
                {{ "automation_plans_form.delete_confirm" | transloco }}
                <button
                        matButton="filled"
                        class="btn-error"
                        (click)="delayField.reset(); confirmDeleteDelay.set(false)"
                >{{ "automation_plans_form.confirm" | transloco }}
                </button>
                <button
                        matButton="filled"
                        class="btn-secondary"
                        (click)="confirmDeleteDelay.set(false)"
                >
                    {{ "automation_plans_form.decline" | transloco }}
                </button>
            </div>
        }
      </div>
      @if(startingTimeField.value > endingTimeField.value) {
      <div [tourAnchor]="periodAnchorId">
        {{ "automation_plans_form.period_description" | transloco }}:
        @for(period of getDays(); track period) {
        <p style="margin: 0; font-size: 12px">
          {{ period.start }} {{ startingTimeField.value }} - {{ period.end }}
          {{ endingTimeField.value }}
        </p>
        }
      </div>
      }
    </form>
  </loren-automation-plan-section>

  <loren-automation-plan-section
    [number]="2"
    [title]="'automation_plans_form.conditions' | transloco"
    [subtitle]="'automation_plans_form.conditions_list' | transloco"
    [tourAnchor]="conditionsAnchorId">
    @if(allConditions().length) {
    <div style="margin-top: 32px">
      @if(allConditions().length > 1) {
      <form [formGroup]="logicalOperatorsForm">
        <mat-radio-group
          required
          style="display: flex; gap: 16px; margin-bottom: 12px"
          formControlName="logicalOperator">
          @for(operator of logicalOperatorOptions; track operator) {
          <mat-radio-button [value]="operator.value">{{
            operator.key | transloco
          }}</mat-radio-button>
          }
        </mat-radio-group>
      </form>
      } @for(condition of allConditions(); track condition) {
      <div style="display: flex; justify-content: space-between">
        <p>{{ getCondition(condition) }}</p>
        <div style="display: flex">
          @if(getConditionAsset(condition)) {
          <button
            mat-icon-button
            type="button"
            aria-label="Edit condition"
            (click)="setConditionsMode('editing', condition)">
            <mat-icon class="loren-automation-plan-edit">edit</mat-icon>
          </button>
          }
          <button
            mat-icon-button
            type="button"
            aria-label="Delete condition"
            (click)="
              getConditionAsset(condition)
                ? setConditionsMode('deleting', condition)
                : confirmDeleteCondition(condition)
            ">
            <mat-icon class="loren-automation-plan-edit">close</mat-icon>
          </button>
        </div>
      </div>
      } @if(conditionsMode() === 'new') {
        <button
                matButton="filled"
                (click)="setConditionsMode('adding')">
            <mat-icon>add_circle_outline</mat-icon>
            {{ "automation_plans_form.add_condition" | transloco }}
        </button>
      }
    </div>
    } @if(!allConditions().length || conditionsMode() !== 'new') {
    <loren-automation-plan-conditions
      [allAssets]="allData().assets"
      [allGeozones]="allData().geozones"
      [allConditions]="allConditions()"
      [mode]="conditionsMode()"
      [condition]="conditionToEdit()"
      (conditionSubmitted)="
        submitCondition($event)
      "></loren-automation-plan-conditions>
    } @if(deletingCondition()) {
    <div class="vertically-centered" style="gap: 8px; margin-top: 16px">
      {{ "automation_plans_form.delete_confirm" | transloco }}
        <button
                matButton="filled"
                class="btn-error"
                (click)="deleteCondition(deletingCondition()); deletingCondition.set(null)"
        >{{ "automation_plans_form.confirm" | transloco }}
        </button>
        <button
                matButton="filled"
                class="btn-secondary"
                (click)="deletingCondition.set(null)"
        >
            {{ "automation_plans_form.decline" | transloco }}
        </button>
    </div>
    }
  </loren-automation-plan-section>

  <loren-automation-plan-section
    [number]="3"
    [title]="'automation_plans_form.actions' | transloco"
    [subtitle]="'automation_plans_form.actions_list' | transloco"
    [tourAnchor]="actionsAnchorId">
    <form class="loren-automation-plan-grid-form" [formGroup]="actionsForm">
      <mat-checkbox formControlName="sendPushNotification">
        {{ getActionText(ActionsEnum.SEND_USER_PUSH_NOTIFICATION) | transloco }}
      </mat-checkbox>
      <mat-checkbox formControlName="sendEmail">
        {{ getActionText(ActionsEnum.SEND_USER_EMAIL) | transloco }}
      </mat-checkbox>
      @if(smsNotificationsEnabled()) {
      <mat-checkbox formControlName="sendSMSNotification">
        {{ getActionText(ActionsEnum.SEND_USER_SMS) | transloco }}
      </mat-checkbox>
      }
      <div>
        <mat-slide-toggle [checked]="soundField.value" (toggleChange)="soundField.setValue(!soundField.value)">
            {{ "automation_plans_form.sound" | transloco }}
        </mat-slide-toggle>
      </div>
      <div class="loren-automation-plan-define-checkbox-with-hint">
        <mat-checkbox formControlName="notifyOnRecovery">
          {{ "automation_plans_form.notify_on_recovery" | transloco }}
        </mat-checkbox>
        <mat-icon
          class="loren-automation-plan-define-hint-icon"
          [matTooltip]="'automation_plans_form.notify_on_recovery_tooltip' | transloco">
          help_outline
        </mat-icon>
      </div>
      @if(sendSMSNotificationField.value) {
      <mat-form-field
        appearance="outline"
        class="loren-form-field loren-form-field-with-chips loren-form-field-automation-plan loren-automation-plan-grid-full-width"
        [ngClass]="{
              'loren-form-field-automation-plan--with-value':
                recipientsField.value,
            }"
        [hideRequiredMarker]="false">
        <mat-label for="recipients">{{
          "automation_plans_form.recipients" | transloco
        }}</mat-label>
        <mat-chip-grid #reactiveChipGrid formControlName="recipients">
          @for (recipient of recipients(); track recipient) {
          <mat-chip (removed)="removeRecipient(recipient)">
            {{ recipient }}
            <button matChipRemove>
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip>
          }
        </mat-chip-grid>
        <input
          matInput
          [placeholder]="
            'automation_plans_form.recipients_placeholder' | transloco
          "
          id="recipients"
          formControlName="recipients"
          [style.width]="'100%'"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matChipInputFor]="reactiveChipGrid"
          (matChipInputTokenEnd)="addRecipient($event.value)"
          (paste)="pasteNumbers($event)" />
        @if(recipientsField.value) {
        <mat-icon matSuffix class="loren-automation-plan-edit"> edit </mat-icon>
        }
        <mat-error>
          @if (recipientsField.hasError('required')) {
          <span>{{ "automation_plans_form.required" | transloco }}</span>
          } @else{
          <span>{{
            "automation_plans_form.phone_number_incorrect" | transloco
          }}</span>
          }
        </mat-error>
      </mat-form-field>
      }
    </form>
  </loren-automation-plan-section>

  <loren-automation-plan-section>
    <div class="loren-automation-plan-define-actions">
      <div class="loren-automation-plan-define-actions-left">
        <button
                matButton="filled"
          class="loren-automation-plan-grid-full-width"
          [disabled]="
            (!sendPushNotificationField.value &&
              !sendEmailField.value &&
              !sendSMSNotificationField.value) ||
            (sendSMSNotificationField.value && !recipients().size) ||
            !allConditions()?.length ||
            baseForm.invalid
          "
          [matTooltip]="
            baseForm.invalid
              ? ('automation_plans_form.error_base_form_invalid' | transloco)
              : !allConditions()?.length
              ? ('automation_plans_form.error_no_condition' | transloco)
              : !sendPushNotificationField.value &&
                !sendEmailField.value &&
                !sendSMSNotificationField.value
              ? ('automation_plans_form.error_no_actions' | transloco)
              : sendSMSNotificationField.value && !recipients().size
              ? ('automation_plans_form.phone_number_incorrect' | transloco)
              : undefined
          "
          (click)="submitRule()">
          {{
            (rule
              ? "automation_plans_form.save_rule"
              : "automation_plans_form.create_rule"
            ) | transloco
          }}
        </button>
          <button
                  matButton="filled"
                  class="btn-secondary"
                  (click)="ruleSubmitted.emit()">
              {{ "automation_plans_form.decline" | transloco }}
          </button>
      </div>
      @if (rule) {
          <button matButton="filled" class="btn-error" (click)="deleteRule()">
              {{ "automation_plans_form.delete_rule" | transloco }}
          </button>
      }
    </div>
  </loren-automation-plan-section>
</loren-page-content>
